export default "/images/vendor/flag-icon-css/flags/4x3/gl.svg?84ac5572fd0727fd850e09e4fc7a8b34";